<template>
  <div>
    <w-popover
      ref="popover"
      trigger="click"
      :visible-arrow="false"
      :open-delay="0"
      :close-delay="0"
      popper-class="padd0 w_popover_container"
      :disabled="disabled"
      @hidden="cancel"
    >
      <div v-if="isShow && !disabled" class="popover-warp">
        <i class="icon-close w-icon-close" @click="cancel"></i>
        <div class="popover-warp-body">
          <AddPeople
            ref="addPerson"
            :key-name="keyName"
            :row="row"
            :index="mergeIndex"
          ></AddPeople>
        </div>

        <div class="popover-footer">
          <div class="popover-footer--right">
            <w-button @click="cancel">取消</w-button>
            <w-button type="primary" @click="confirm">确认</w-button>
          </div>
        </div>
      </div>
      <template slot="reference">
        <div @click="show">
          <w-tooltip
            :disabled="isTip"
            :content="value"
            placement="top-start"
            theme="dark"
          >
            <w-input
              slot="reference"
              :value="value"
              disabled
              placeholder="请选择"
              class="wued-input"
              :class="{ actived: isShow }"
            >
              <template slot="suffix"
                ><w-button
                  type="text"
                  icon="w-icon-template"
                  size="large"
                ></w-button>
              </template>
            </w-input>
          </w-tooltip>
        </div>
      </template>
    </w-popover>
  </div>
</template>

<script>
import AddPeople from './module/AddPeople'
export default {
  name: 'PopoverInput',
  components: { AddPeople },
  props: {
    //整行对象
    row: {
      type: Object,
      default: () => {}
    },

    valueKey: {
      //id
      type: String,
      default: ''
    },
    valueName: {
      //name
      type: String,
      default: ''
    },
    // 表格行 单框默认0
    index: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mergeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isShow: false,
      detail: {}
    }
  },
  computed: {
    value() {
      if (this.row.isErgodicList) {
        return this.row.jsrArr[this.mergeIndex].Jsrqc
      } else {
        return this.row.Jsrqc
      }
    },
    keyName() {
      return {
        key: this.valueKey,
        name: this.valueName
      }
    },
    isTip() {
      if (!this.value || this.value.length < 10) {
        return true
      } else {
        return false
      }
    }
  },

  created() {},
  methods: {
    show() {
      if (this.disabled) {
        this.$msg('请先选择接收科室')
      }
      this.isShow = true
    },

    //确认 按钮提交
    confirm() {
      this.detail = this.$refs.addPerson.getPersonName()
      this.$emit('changeValue', this.detail, this.index, this.mergeIndex)
      this.cancel()
    },
    //取消
    cancel() {
      this.isShow = false
      this.$refs['popover'].showPopper = false
    }
  }
}
</script>
<style lang="scss" scoped>
.pic-people {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>
